import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import styled, { withTheme } from "styled-components";
import { profiles } from "../../../modules/constants";
import { infoBaseUrl } from "../../../config";
import {
  mapDispatchToPropsLayout,
  mapStateToPropsLayout,
} from "../../../modules/layout";
import { mapStateToPropsLogin } from "../../../modules/login";
import ImgCommunity from "../../../assets/sidebar-icons/Rarify Community.svg";
import { useTranslation } from "react-i18next";
import { getCurrentLocale } from "../../../i18n/helpers";
import SideBarItem from "./SideBarItem/SideBarItem";
import { appStudy } from "../../../config";
import { checkIfAppIsInMobile } from "../../../modules/utils";

const StyledNavbar = styled.nav`
  background-color: ${({ theme }) => theme?.white};
  color: ${({ theme }) => theme?.fg};
  margin-left: -60px;
  margin-top: -30px;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease-in-out;
  position: fixed;
  height: 100%;
  min-width: 80px;
  max-width: 80px;
  z-index: 1040;
  left: 60px;
  &:hover {
    box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.05);
  }
  & > .list-unstyled {
    margin-bottom: 0px;
  }

  &.active {
    min-width: 160px;
    max-width: 160px;
    text-align: center;
  }

  ul li a {
    text-decoration: none;
    text-align: center;
    border-top: 1px solid ${({ theme }) => theme?.concrete};
    color: #b7b5b7;
    padding: 1rem;
    font-weight: 100;
    font-size: 1rem;
    display: block;
  }
  ul li:last-child a {
    text-align: center;
    border-bottom: 1px solid ${({ theme }) => theme?.concrete};
  }
  &.active ul li a {
    padding: 1rem;
    text-align: center;
    font-size: 1rem;
  }
  ul li a span {
    opacity: 0;
    font-size: 0.85em;
    font-weight: 600;
    display: block;
    margin-bottom: -20px;
  }
  &.active ul li a span {
    margin-bottom: 0;
    opacity: 1;
  }
  &.active ul li div span {
    margin-bottom: 0;
    opacity: 1;
  }
  &.active ul li a i {
    margin-right: 0;
    font-size: 1rem;
  }

  &.active .dropdown-toggle::after {
    top: auto;
    bottom: 10px;
    right: 50%;
    -webkit-transform: translateX(50%);
    -ms-transform: translateX(50%);
    transform: translateX(50%);
  }

  ul li a:hover {
    text-decoration: none;
    color: ${({ theme }) => theme?.darkPurple};
    background: ${({ theme }) => theme?.white};
  }
  ul li.active img,
  ul li a:hover img {
    filter: invert(19%) sepia(55%) saturate(4343%) hue-rotate(296deg)
      brightness(86%) contrast(91%);
  }
  ul li div:hover {
    text-decoration: none;
    color: ${({ theme }) => theme?.darkPurple};
    background: ${({ theme }) => theme?.white};
  }
  ul li a i {
    margin-right: 0px;
  }
  ul li.active > a {
    background: ${({ theme }) => theme?.white};
    color: ${({ theme }) => theme?.darkPurple};
    text-decoration: none;
  }
  &.dropdown-toggle::after {
    display: block;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
  }

  ul ul a {
    font-size: 0.9em !important;
    padding-left: 30px !important;
    background: #232323;
  }

  @media (max-width: 1024px) {
    min-width: 80px;
    max-width: 80px;
    text-align: center;
    margin-left: -140px !important;
    margin-left: 0;
    &.active {
      margin-left: -60px !important;
    }
    .sidebar-header strong {
      display: block;
    }
    ul li a {
      padding: 20px 10px;
    }

    ul li a i {
      margin-right: 0;
      display: block;
    }
    ul ul a {
      padding: 10px !important;
    }
    ul li a i {
      font-size: 1.3em;
    }
  }
`;

const StyledImg = styled.img`
  filter: opacity(40%);
  &:hover,
  &:active {
    filter: invert(19%) sepia(55%) saturate(4343%) hue-rotate(296deg)
      brightness(86%) contrast(91%);
  }
`;

const Sidebar = (props) => {
  const {
    isSidebarCollapsed,
    claims,
    canViewComments,
    canViewUserGuide,
    toggleLayoutSidebar,
  } = props;

  const { t } = useTranslation();
  const [infoUrl, setInfoUrl] = React.useState("");

  React.useEffect(() => {
    const fetchInfoUrl = async () => {
      try {
        const baseUrl = await infoBaseUrl();
        setInfoUrl(
          `${baseUrl}${appStudy.toUpperCase()}_INFO_${getCurrentLocale()}.pdf`
        );
      } catch (error) {
        console.error("Error fetching info URL:", error);
      }
    };
    fetchInfoUrl();
  }, []);

  const closeSidebarInMobile = () => {
    if (checkIfAppIsInMobile()) {
      toggleLayoutSidebar();
    }
  };

  return (
    <>
      <StyledNavbar className={isSidebarCollapsed ? "" : "active"} id="sidebar">
        {props.userProfile === profiles.participant && (
          <ul className="list-unstyled components">
            <li
              className={
                props.location.pathname === "/participant" ? "active" : ""
              }
              data-testid="sidebar-participant"
              onClick={() => closeSidebarInMobile()}
            >
              <SideBarItem
                linkTo="/participant"
                title={t("appText.dietDiary")}
                iconClass="fas fa-utensils"
                isSidebarCollapsed={isSidebarCollapsed}
              />
            </li>
            <li
              className={props.location.pathname === "/stats" ? "active" : ""}
              data-testid="sidebar-stats"
              onClick={() => closeSidebarInMobile()}
            >
              <SideBarItem
                linkTo="/stats"
                title={t("appText.stats")}
                iconClass="fas fa-chart-pie"
                isSidebarCollapsed={isSidebarCollapsed}
              />
            </li>

            <li
              className={
                props.location.pathname === "/favorites" ? "active" : ""
              }
              data-testid="sidebar-favorites"
              onClick={() => closeSidebarInMobile()}
            >
              <SideBarItem
                linkTo="/favorites"
                title={t("appText.favorites")}
                iconClass="fas fa-star"
                isSidebarCollapsed={isSidebarCollapsed}
              />
            </li>

            {canViewUserGuide && (
              <li
                data-testid="sidebar-info"
                onClick={() => closeSidebarInMobile()}
              >
                <a
                  href={infoUrl}
                  target="_blank"
                  rel="noreferrer noopener"
                  title={t("appText.info")}
                  download
                >
                  <i className="fas fa-info-circle" aria-hidden="true"></i>
                  {!isSidebarCollapsed && <span>{t("appText.info")}</span>}
                </a>
              </li>
            )}
          </ul>
        )}

        {/* If not participant */}
        {props.userProfile !== profiles.participant &&
          props.userProfile !== profiles.itAdmin && (
            <ul className="list-unstyled components">
              <li
                className={props.location.pathname === `/admin` ? "active" : ""}
                data-testid="sidebar-admin"
              >
                <SideBarItem
                  linkTo="/admin"
                  title="Home"
                  isSidebarCollapsed={isSidebarCollapsed}
                >
                  <StyledImg
                    alt=""
                    src={ImgCommunity}
                    width="36px"
                    height="24px"
                    className={`svg-img ${
                      props.location.pathname === `/admin` ? "active" : ""
                    }`}
                  />
                </SideBarItem>
              </li>
              {claims?.includes("mealLog.changeRequest.canView") && (
                <li
                  className={
                    props.location.pathname === "/change-requests"
                      ? "active"
                      : ""
                  }
                  data-testid="sidebar-change-requests"
                >
                  <SideBarItem
                    linkTo="/change-requests"
                    title="Change requests"
                    iconClass="fas fa-exchange-alt fa-lg"
                    isSidebarCollapsed={isSidebarCollapsed}
                  />
                </li>
              )}

              {canViewComments && (
                <li
                  className={
                    props.location.pathname === "/data-comments" ? "active" : ""
                  }
                  data-testid="sidebar-data-comments"
                >
                  <SideBarItem
                    linkTo="/data-comments"
                    title="Data Comments"
                    iconClass="fas fa-comment-alt fa-lg"
                    isSidebarCollapsed={isSidebarCollapsed}
                  />
                </li>
              )}
            </ul>
          )}
        {[profiles.itAdmin].includes(props.userProfile) && (
          <ul className="list-unstyled components">
            <li
              className={
                props.location.pathname === "/management" ? "active" : ""
              }
            >
              <SideBarItem
                linkTo="/management"
                title="Management"
                isSidebarCollapsed={isSidebarCollapsed}
              >
                <StyledImg
                  alt=""
                  src={ImgCommunity}
                  width="36px"
                  height="24px"
                  className={`svg-img ${
                    props.location.pathname === `/management` ? "active" : ""
                  }`}
                />
              </SideBarItem>
            </li>
          </ul>
        )}
        {[
          profiles.dietitian,
          profiles.medicalMonitor,
          profiles.siteMonitor,
          profiles.sponsor,
          profiles.siteCoordinator,
          profiles.pi,
          profiles.studyAdmin,
          profiles.itAdmin,
        ].includes(props.userProfile) && (
          <ul className="list-unstyled components">
            <li
              className={
                props.location.pathname === "/audittrail" ? "active" : ""
              }
            >
              <SideBarItem
                linkTo="/audittrail"
                title="Audit Trail"
                iconClass="fas fa-glasses fa-lg"
                isSidebarCollapsed={isSidebarCollapsed}
              />
            </li>
          </ul>
        )}
      </StyledNavbar>
    </>
  );
};

const mapStateToProps = (state) => ({
  ...mapStateToPropsLogin(state),
  ...mapStateToPropsLayout(state),
});

export default connect(
  mapStateToProps,
  mapDispatchToPropsLayout
)(withRouter(withTheme(Sidebar)));
